import React from 'react'
import classes from './cassetsEdit.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import {DoctorService} from "../../api/DoctorService";
import { ScanCompleted } from '../../store/reducers/ScanReducer/RegistrationScanReducer';
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom';
import {ClearInputs} from "../../store/reducers/ScanReducer/RegistrationScanReducer";

const CassetsEdit = ({onChange , type, onEdited}) => {

  const form = useSelector(state=>state.RegScan.ScanInputs)

  const closeButton = () => {
    onChange()
  }
  
  const dispatch = useDispatch()

  const addHandler = () => {
    let value = +(document.querySelector('#number').value)
    value = value + (+form.quantityMaterial)
    changeQuant(form.id, value)
    // dispatch(ClearInputs())
    onChange(value)
    onEdited(true)
  }

  const removeHandler = () =>{
    let value = document.querySelector('#number').value
    value = (+form.quantityMaterial) - value
    if(value <= 0){
      changeQuant(form.id, 1)
    } else {
      changeQuant(form.id, value)
    }
    // dispatch(ClearInputs())
    onChange(value)
  }

  const changeQuant = async(id,value) => {
    let obj = {
      "status": 'registered',
      "quantityMaterial": value,
      "research": form.research,
      "id": id
    }
    dispatch(ScanCompleted({credential: obj}))
    await DoctorService.updateStatusDirection(id, {"status": 'registered'}).then(res => {
      if (res) toast.done('Скерування оновлено')
    })
    await DoctorService.updateStatusDirection(id, {"quantityMaterial": value}).then(res => {
      if (res) toast.info('Кількість касет змінена')
    })
  } 
  
  return (
    <div className={classes.container}>
      <button type='button' onClick={closeButton} className={classes.closeButton}>
        X
      </button>   
      <h1>Введіть кількість кассет</h1>
      <div className={classes.buttonContainer}>
        <button type='button' onClick={addHandler} className={classes.button}>Додати</button>
        <button type='button' onClick={removeHandler} className={classes.button}>Зменшити</button>
      </div>
      <input className={classes.input} required id='number' type='number' placeholder='Введіть кількість' min='0' max='50'/>
    </div>
  )
}

export default CassetsEdit